import React, { useState } from 'react';
import ConfirmationModal from './ConfirmationModal';

export function EmailSignup() {
  const [formData, setFormData] = useState({ email: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email) return;

    try {
      setIsSubmitting(true);
      setError("");

      const formDataObj = new FormData();
      formDataObj.append('firstname', 'Header Email Signup');
      formDataObj.append('lastname', '');
      formDataObj.append('email', formData.email);
      formDataObj.append('business_name', '');
      formDataObj.append('product_category', '');
      formDataObj.append('website', '');
      formDataObj.append('message', `A visitor with email ${formData.email} requested a demo from the header form.`);

      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      const response = await fetch('/submit_demo_request', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        },
        body: formDataObj
      });

      if (response.ok) {
        setFormData({ email: "" });
        setShowModal(true);
      } else {
        setError("Failed to submit. Please try again.");
      }
    } catch (err) {
      setError("Failed to submit. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="tw-flex tw-flex-col tw-items-start tw-mt-4 tw-text-lg tw-rounded-lg"
        style={{ maxWidth: "557px" }}
        aria-label="Newsletter signup form"
      >
        <div className="tw-flex tw-gap-5 tw-w-full tw-justify-between tw-pl-8 tw-bg-white tw-rounded-lg" style={{ maxWidth: "470px" }}>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="Email"
            aria-label="Email address"
            className="tw-my-auto tw-leading-snug tw-text-neutral-800 tw-border-none focus:tw-outline-none"
            disabled={isSubmitting}
            required
          />
          <button
            type="submit"
            className="tw-cursor-pointer tw-z-10 tw-px-4 md:tw-px-12 tw-py-5 tw-mr-0 tw-border-0 tw-font-extrabold tw-text-center tw-text-white tw-uppercase tw-bg-color1 tw-rounded-lg"
            disabled={isSubmitting}
            aria-busy={isSubmitting}
          >
            {isSubmitting ? 'Requesting...' : 'Request demo'}
          </button>
        </div>
        {error && (
          <div role="alert" className="tw-mt-2 tw-text-red-500">
            {error}
          </div>
        )}
      </form>

      <ConfirmationModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Request Received!"
        message="Thank you for your interest! We've received your demo request and will get back to you shortly."
      />
    </>
  );
}
